import type { Market } from '@packages/locale/types/locales.ts'
import {
  isMarketSol,
  isMarketRolfs,
  isMarketRolfsTours,
} from '@packages/locale/utils/market.ts'

export default defineNuxtPlugin<{ isSolWebsite: boolean; isRolfsWebsite: boolean; isRolfsToursWebsite: boolean; locale: Market }>((nuxtApp) => {
  const { market } = nuxtApp.$config.public

  const isSolWebsite = isMarketSol(market)
  const isRolfsWebsite = isMarketRolfs(market)
  const isRolfsToursWebsite = isMarketRolfsTours(market)

  return {
    provide: {
      isSolWebsite,
      isRolfsWebsite,
      isRolfsToursWebsite,
      locale: market,
    },
  }
})
